import api from "src/configs/api";
import {
  ADD_SEQUENCE_TAGS,
  EDIT_SEQUENCE_DETAIL,
  GET_FILES_DOWNLOAD_SEQUENCE_PACKAGE,
  GET_SEQUENCE_DETAIL,
  GET_SEQUENCE_TAGS,
  GET_SEQUENCES,
  GET_TEST_PACKAGE_OPTIONS,
} from "src/constant/endpoint";

const getSequences = async (params) => await api.get(GET_SEQUENCES, { params }).then((response) => response?.data?.data);

const getTestPackageOptions = async (instanceId) =>
  await api.get(GET_TEST_PACKAGE_OPTIONS(instanceId)).then((response) => response?.data?.data);

const getSequenceDetail = async (id) => await api.get(GET_SEQUENCE_DETAIL(id)).then((response) => response?.data?.data);

const editSequenceDetail = ({ data, id }) => api.put(EDIT_SEQUENCE_DETAIL(id), { data }).then((response) => response?.data);

const getFilesDownloadSequencePackage = async (params) =>
  await api.post(GET_FILES_DOWNLOAD_SEQUENCE_PACKAGE, { data: params }).then((response) => response?.data?.data);

const getSequenceTags = (id) => api.get(GET_SEQUENCE_TAGS(id)).then((response) => response?.data);

const addSequenceTags = ({ data }) => api.post(ADD_SEQUENCE_TAGS, { data }).then((response) => response?.data);

export {
  getSequences,
  getTestPackageOptions,
  getSequenceDetail,
  editSequenceDetail,
  getFilesDownloadSequencePackage,
  getSequenceTags,
  addSequenceTags,
};
